(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    // Unpublished-language review stays confined to this local development target.
  function isLocalLanguagePreview() {
    return ['localhost', '127.0.0.1'].includes(window.location.hostname) && window.Shopify?.theme?.id === 189310140726;
  }

  function updatePreviewLanguageLink(link) {
    const path = window.location.pathname.replace(/^\/ar(?=\/|$)/, '') || '/';
    const target = link.dataset.previewLanguageCode === 'ar' ? `/ar${path === '/' ? '/' : path}` : path;
    link.setAttribute('href', target + window.location.search + window.location.hash);
    link.dataset.previewOnly = 'true';
  }

  function enableLocalLanguagePreview() {
    if (!isLocalLanguagePreview()) return;
    for (const template of document.querySelectorAll('template[data-language-preview]')) {
      const content = template.content.cloneNode(true);
      const link = content.querySelector('[data-preview-language-code]');
      if (!link) continue;
      updatePreviewLanguageLink(link);
      template.replaceWith(content);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enableLocalLanguagePreview, { once: true });
  else enableLocalLanguagePreview();

  function refreshPreviewLanguageLink(event) {
    if (!isLocalLanguagePreview() || !(event.target instanceof Element)) return;
    const link = event.target.closest('[data-preview-only="true"][data-preview-language-code]');
    if (link) updatePreviewLanguageLink(link);
  }
  for (const eventName of ['pointerdown', 'focusin', 'click']) document.addEventListener(eventName, refreshPreviewLanguageLink);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-language-switcher]')) return;
    const returnTo = form.elements.namedItem('return_to');
    if (returnTo instanceof HTMLInputElement) {
      returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["playroots-color"] && !Shopify.designMode) return;
  try {
    if (!window.__playrootsImgErrorBound) {
    window.__playrootsImgErrorBound = true;
    document.addEventListener(
      'error',
      (event) => {
        const target = event.target;
        if (target instanceof HTMLImageElement) {
          target.classList.add('playroots-img-broken');
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
